<template>
  <div>
    <el-dialog
      top="10vh"
      width="490px"
      center
      title="密码管理"
      :visible="passwordDialogObj.visible"
      @close="HandleCancel()"
    >
      <el-form :rules="rules" :model="editData" :ref="form" label-width="85px">
        <el-form-item label="用户名">
          {{ passwordDialogObj.username }}
        </el-form-item>
        <el-form-item prop="newPassword" label="新密码">
          <el-input
            size="small"
            style="width: 200px"
            :type="!showNewPassword ? 'password' : ''"
            v-model="editData.newPassword"
          >
            <span
              slot="suffix"
              class="cursorPointer"
              @click="showNewPassword = !showNewPassword"
            >
              <svg-icon
                :icon-class="!showNewPassword ? 'eye' : 'eye-open'"
                class="color-main"
              ></svg-icon>
            </span>
          </el-input>
          <el-button
            size="small"
            @click="
              const password = generateRandomPassword();
              editData.newPassword = password;
              confirmNewPassword = password;
            "
            >随机生成</el-button
          ><el-button
            :disabled="!editData.newPassword"
            size="small"
            icon="el-icon-document-copy"
            @click="
              CopyTextToClipboard(
                editData.newPassword,
                '已复制密码至剪贴板，请谨慎管理您的密码！'
              )
            "
          ></el-button>
        </el-form-item>
        <el-form-item label="确认新密码">
          <el-input
            size="small"
            style="width: 200px"
            :type="!showNewPassword ? 'password' : ''"
            v-model="confirmNewPassword"
          >
            <span
              slot="suffix"
              class="cursorPointer"
              @click="showNewPassword = !showNewPassword"
            >
              <svg-icon
                :icon-class="!showNewPassword ? 'eye' : 'eye-open'"
                class="color-main"
              ></svg-icon>
            </span>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button round @click="HandleCancel()"> 取消 </el-button>
        <el-button
          :loading="submitLoading"
          round
          type="success"
          @click="HandleVaild()"
        >
          保存
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import { replacePassword } from "@/api/user";

export default {
  mixins: [mainCommon],
  props: ["passwordDialogObj"],
  data() {
    return {
      showNewPassword: false,
      submitLoading: false,
      confirmNewPassword: null, // 确认新密码
      form: "form",
      editData: {
        newPassword: null,
      },
      rules: {
        newPassword: [
          {
            required: true,
            message: "需包含英文大小写、特殊字元及数字，长度不可少于 10 位",
            pattern:
              /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{10,}$/,
          },
        ],
      },
    };
  },
  methods: {
    HandleCancel() {
      this.editData = {
        newPassword: null,
      };
      this.confirmNewPassword = null;
      this.showNewPassword = false;
      this.$refs[this.form].resetFields();
      this.$emit("update:password-dialog-obj", {});
    },
    HandleVaild() {
      if (!/[a-z]/.test(this.editData.newPassword)) {
        return this.$notify.error("新密码缺少英文小写");
      }
      if (!/[A-Z]/.test(this.editData.newPassword)) {
        return this.$notify.error("新密码缺少英文大写");
      }
      if (!/\d/.test(this.editData.newPassword)) {
        return this.$notify.error("新密码缺少数字");
      }
      if (
        !/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(this.editData.newPassword)
      ) {
        return this.$notify.error("新密码缺少特殊符号");
      }
      if (this.confirmNewPassword !== this.editData.newPassword) {
        return this.$notify.error("新密码与确认新密码不同");
      }

      this.$refs[this.form].validate((valid) => {
        if (valid) this.HandleSubmit();
      });
    },
    HandleSubmit() {
      this.submitLoading = true;
      replacePassword({
        userId: this.passwordDialogObj.id,
        newPassword: this.editData.newPassword,
      })
        .then((res) => {
          this.$notify.success(res.message);
          this.HandleCancel();
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/user/PasswordDialog.vue